import { createSlice } from '@reduxjs/toolkit';
import { PermissionSetsStore } from './store';
export const permissionSetsSlice = createSlice({
    name: '@@PERMISSION_SETS',
    initialState: PermissionSetsStore.empty(),
    reducers: (create)=>({
            putAll: create.reducer((state, { payload: sets })=>PermissionSetsStore.putAll(sets)(state))
        })
});
